import { extractConditionBlocks } from '../utils';

const APPEND_REQUIRED_PATTERN =
  /\$\(\s*["']\[id\^=['"]?([\w]+)['"]?\]["']\s*\)(?:\s*\.\w+\([^)]*\))*\s*\.append\(\s*(?:"[^"]*red[^"]*<\/span>[^"]*"|'[^']*red[^']*<\/span>[^']*')\s*\)/g;

const REMOVE_REQUIRED_PATTERN =
  /\$\(\s*["']\[id\^=['"]?([\w]+)['"]?\]["']\s*\)(?:\s*\.\w+\([^)]*\))*?\s*\.find\(\s*["'][^"']*span\.red[^"']*["']\s*\)\s*\.remove\(\)/g;

export function detectRequiredPatterns(script, ownerFieldKey) {
  if (!script) return [];
  const effects = [];
  const conditionBlocks = extractConditionBlocks(script);

  conditionBlocks.forEach(({ condition, body }) => {
    const actions = [];

    let match;

    APPEND_REQUIRED_PATTERN.lastIndex = 0;
    while ((match = APPEND_REQUIRED_PATTERN.exec(body)) !== null) {
      const prefix = match[1];
      if (prefix) {
        actions.push({ target: `${prefix}*`, action: 'setRequired', value: true });
      }
    }

    REMOVE_REQUIRED_PATTERN.lastIndex = 0;
    while ((match = REMOVE_REQUIRED_PATTERN.exec(body)) !== null) {
      const prefix = match[1];
      if (prefix) {
        actions.push({ target: `${prefix}*`, action: 'clearRequired' });
      }
    }

    if (actions.length > 0) {
      effects.push({ when: condition, actions });
    }
  });

  return effects;
}
